"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ToolbarActionPlugin;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _draftExtend = require("draft-extend");

var _SmallToggleButton = _interopRequireDefault(require("draft-plugins/components/SmallToggleButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

function renderInner(icon, messageKey) {
  if (icon) {
    return _react.default.createElement(_UIIcon.default, {
      name: icon
    });
  } else if (messageKey) {
    return _react.default.createElement(_FormattedHTMLMessage.default, {
      message: messageKey
    });
  }

  return null;
}

var MemoedToolbarActionPlugin = _react.default.memo(function (_ref) {
  var tooltip = _ref.tooltip,
      tooltipPlacement = _ref.tooltipPlacement,
      onClick = _ref.onClick,
      icon = _ref.icon,
      messageKey = _ref.messageKey;
  return _react.default.createElement(_UITooltip.default, {
    disabled: !tooltip,
    title: tooltip,
    placement: tooltipPlacement
  }, _react.default.createElement(_UIButton.default, {
    onClick: onClick
  }, renderInner(icon, messageKey)));
});

function createActionButton(options) {
  var ActionButton =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(ActionButton, _React$Component);

    function ActionButton() {
      (0, _classCallCheck2.default)(this, ActionButton);
      return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ActionButton).apply(this, arguments));
    }

    (0, _createClass2.default)(ActionButton, [{
      key: "handleClick",
      value: function handleClick() {
        var closePopover = this.props.closePopover;

        if (options.onClick) {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          options.onClick.apply(this, args);
        }

        if (closePopover) {
          closePopover();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _options$hasToolbarBe = options.hasToolbarBeta,
            hasToolbarBeta = _options$hasToolbarBe === void 0 ? false : _options$hasToolbarBe,
            icon = options.icon,
            tooltip = options.tooltip,
            _options$tooltipPlace = options.tooltipPlacement,
            tooltipPlacement = _options$tooltipPlace === void 0 ? 'bottom' : _options$tooltipPlace,
            onClick = options.onClick,
            messageKey = options.messageKey;

        if (hasToolbarBeta) {
          return _react.default.createElement(_SmallToggleButton.default, {
            active: false,
            icon: icon,
            onClick: this.handleClick,
            tooltip: tooltip,
            tooltipPlacement: tooltipPlacement
          });
        }

        return _react.default.createElement(MemoedToolbarActionPlugin, {
          tooltip: tooltip,
          placement: tooltipPlacement,
          onClick: onClick,
          icon: icon,
          messageKey: messageKey
        });
      }
    }]);
    return ActionButton;
  }(_react.default.Component);

  ActionButton.propTypes = {
    closePopover: _react.PropTypes.func
  };
  return ActionButton;
}

function ToolbarActionPlugin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _draftExtend.createPlugin)({
    displayName: 'ToolbarActionPlugin',
    buttons: createActionButton(options)
  });
}

module.exports = exports.default;